export default function getArrayTagsHtmlString(str) {
  const doc = new DOMParser().parseFromString(str, "text/html");
  return [...doc.body.childNodes].map(
    (child) => child.outerHTML || child.textContent
  );
}
